import { component } from '../mixins/component';

export const TwitchAPI = {
  mixins: [component],
  methods: {
  },
};
